import { SelectListValueType } from 'complex-data/src/data/SelectList'
import { LoadControlItemInitOption } from '@/class/LoadControl'
import ComplexSelect from '@/class/ComplexSelect'
import selectApi, { locationValue } from '../api/select'
import selectLoad from './load'

export interface locationSelectValueType extends SelectListValueType<string> {
  children?: locationSelectValueType[]
}

const formatList = function(list: locationValue[]) {
  return list.map((oitem) => {
    const item = {
      value: oitem.bankNo,
      label: oitem.bankName
    } as locationSelectValueType
    if (oitem.regionList) {
      item.children = formatList(oitem.regionList)
    }
    return item
  })
}

export const loadLocationList = function(): Promise<{ status: string, data: SelectListValueType<string>[] }> {
  return new Promise((resolve, reject) => {
    selectApi.location.require().then((res) => {
      const locationList = formatList(res.data.data)
      resolve({ status: 'success', data: locationList })
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error(err)
      reject(err)
    })
  })
}

export const location = new ComplexSelect<locationSelectValueType>({
  name: '省市区',
  list: [],
  getData() {
    return new Promise((resolve, reject) => {
      selectLoad.pushControl('location', {
        offset: 10 * 1000,
        priority: 1,
        local: 'location',
        check (localData) {
          if (localData) {
            return true
          }
        },
        load() {
          return loadLocationList()
        },
        init(initData) {
          location.setList(initData)
        }
      } as LoadControlItemInitOption<SelectListValueType<string>[]>).then(res => {
        resolve({ status: res.status, list: res.data })
      }).catch(reject)
    })
  }
})
